import isEqual from 'lodash/isEqual';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FormEditorWrapper from './FormEditorWrapper/FormEditorWrapper';
import {
  getFormEditorIsAutoSave,
  getSelectedFormEditorForm,
  initFormsFromLocalstorage,
  selectForm,
  unselectForm,
} from './store/slices/formEditorSlice';
import { updateFormEditorFormThunk } from './store/thunks/formEditorThunks';

export const FormEditor = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { id } = useParams();

  const selectedForm = useSelector(getSelectedFormEditorForm);
  const isAutoSave = useSelector(getFormEditorIsAutoSave);
  const prevFormRef = useRef(null);

  useEffect(() => {
    if (!selectedForm) {
      if (id === 'new') return;
      dispatch(initFormsFromLocalstorage());
      dispatch(selectForm({ id }));
    }

    if (!isAutoSave) return;

    // Compare current form with previous
    if (isEqual(prevFormRef.current, selectedForm)) {
      return; // No change — skip autosave
    }

    // Update the stored value
    prevFormRef.current = selectedForm;
    // Update the previous form ref
    prevFormRef.current = selectedForm;
    const debounceTimer = setTimeout(() => {
      enqueueSnackbar('Tallennettu onnistuneesti', { variant: 'success' });
      dispatch(updateFormEditorFormThunk());
    }, 4000);

    return () => {
      clearTimeout(debounceTimer); // Clear previous timeout if `selectedForm` changes quickly
    };
  }, [selectedForm]);

  useEffect(() => {
    return () => {
      dispatch(unselectForm());
    };
  }, []); // empty dependency array = run once on mount, and clean up on unmount

  return (
    <>
      <FormEditorWrapper></FormEditorWrapper>
    </>
  );
};
